import { render, staticRenderFns } from "./companySetupsCore.vue?vue&type=template&id=646cdfbc"
import script from "./companySetupsCore.vue?vue&type=script&lang=js"
export * from "./companySetupsCore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports